import { Hidden, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'

import useStyles from './styles/ContractsTable.styles'

const ContractRowSkeleton: React.FC = () => {
  const classes = useStyles()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <>
      <div
        className={[
          classes.tableRow,
          isSmallScreen ? classes.tableRowForSmallScrren : ''
        ].join(' ')}>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>

        <Hidden smDown>
          <div>
            <Typography variant="body1">
              <Skeleton animation="wave" className={classes.skeleton} />
            </Typography>
          </div>
          <div>
            <Typography variant="body1">
              <Skeleton animation="wave" className={classes.skeleton} />
            </Typography>
          </div>
          <div>
            <Typography variant="body1">
              <Skeleton animation="wave" className={classes.skeleton} />
            </Typography>
          </div>
          <div>
            <Typography variant="body1">
              <Skeleton animation="wave" className={classes.skeleton} />
            </Typography>
          </div>
        </Hidden>
        <div />
      </div>
    </>
  )
}

export default ContractRowSkeleton
